import request from "@/utils/request";
// 生成接收人二维码
export function getReceiverQrcode(params) {
  return request({
    url: "/h5/index/getReceiverQrcode",
    method: "post",
    params,
  });
}
// 子账号分流生成接收人二维码
export function addShuntAccount(params) {
  return request({
    url: "/h5/setting/addShuntAccount",
    method: "post",
    params,
  });
}
// 轮询二维码扫码状态
export function GetQrCodeStatus(params) {
  return request({
    url: "/h5/index/getQrCodeStatus",
    method: "post",
    show_loading: false,
    params,
  });
}
// 获取店铺下拉列表
export function CheckShuntAccount(params) {
  return request({
    url: "/h5/setting/checkShuntAccount",
    method: "post",
    show_loading: false,
    params,
  });
}
// 验证接收人姓名是否存在
export function checkReciver(params) {
  return request({
    url: "/h5/setting/checkReciver",
    method: "post",
    show_loading: true,
    params,
  });
}
